import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
  width: 100%;
`;
